import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceHero from '../components/ServiceHero';
import ServiceFeatures from '../components/ServiceFeatures';
import ServiceDetails from '../components/ServiceDetails';
import ServiceCTA from '../components/ServiceCTA';
import { useTranslation } from 'react-i18next';

export default function MarketingPage() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-bar-chart-line', title: t('servicePages.marketing.features.f1.title'), desc: t('servicePages.marketing.features.f1.desc') },
    { icon: 'ri-global-line', title: t('servicePages.marketing.features.f2.title'), desc: t('servicePages.marketing.features.f2.desc') },
    { icon: 'ri-mail-line', title: t('servicePages.marketing.features.f3.title'), desc: t('servicePages.marketing.features.f3.desc') },
    { icon: 'ri-smartphone-line', title: t('servicePages.marketing.features.f4.title'), desc: t('servicePages.marketing.features.f4.desc') },
    { icon: 'ri-video-line', title: t('servicePages.marketing.features.f5.title'), desc: t('servicePages.marketing.features.f5.desc') },
    { icon: 'ri-line-chart-line', title: t('servicePages.marketing.features.f6.title'), desc: t('servicePages.marketing.features.f6.desc') },
  ];

  const details = [
    {
      label: t('servicePages.marketing.details.d1.label'),
      title: t('servicePages.marketing.details.d1.title'),
      body: t('servicePages.marketing.details.d1.body'),
      image: 'https://public.readdy.ai/ai/img_res/7161ff2ee9eb2eb8836662ecbebf7f2b.jpg',
      reverse: false,
    },
    {
      label: t('servicePages.marketing.details.d2.label'),
      title: t('servicePages.marketing.details.d2.title'),
      body: t('servicePages.marketing.details.d2.body'),
      image: 'https://readdy.ai/api/search-image?query=creative%20advertising%20content%20production%20setup%20with%20brand%20materials%2C%20promotional%20banners%20and%20digital%20ad%20creatives%20displayed%20on%20dark%20background%2C%20professional%20marketing%20assets%20layout%2C%20cyan%20and%20white%20color%20scheme%2C%20clean%20studio%20environment%2C%20no%20people%2C%20high%20contrast%20moody%20lighting&width=800&height=500&seq=marketing-detail-02&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0f1419]">
      <Header />
      <main>
        <ServiceHero
          icon="ri-megaphone-line"
          label={t('servicePages.marketing.label')}
          title={t('servicePages.marketing.title')}
          subtitle={t('servicePages.marketing.subtitle')}
          bgImage="https://readdy.ai/api/search-image?query=dark%20futuristic%20advertising%20and%20marketing%20background%20with%20abstract%20digital%20campaign%20elements%2C%20glowing%20data%20streams%20and%20promotional%20graphics%2C%20deep%20navy%20graphite%20atmosphere%20with%20cyan%20neon%20accents%2C%20professional%20marketing%20concept%2C%20ultra%20wide%20panoramic%2C%20cinematic%20dark%20moody%20lighting%2C%20no%20people&width=1920&height=900&seq=marketing-hero-bg-001&orientation=landscape"
        />
        <ServiceFeatures features={features} />
        <ServiceDetails details={details} />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
